<template>
  <div class="daifa-integration">
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>会员中心</el-breadcrumb-item>
      <el-breadcrumb-item>代发对接</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="main" v-loading="loading">
      <div slot="header">
        <b>领星 OMS 代发对接</b>
      </div>
      <p class="hint">
        填写领星开放平台 AppKey/AppSecret（与管理端「编辑客户 → 平台配置」同一套凭证）。
        用于库存同步、入库进度、头程代发推送与箱唛；出库仍在领星 OMS 操作。
        保存后仅显示脱敏；留空表示不修改。
      </p>

      <el-form ref="keyForm" :model="keyForm" label-width="120px" class="key-form">
        <el-form-item label="平台">
          <el-input value="领星" disabled style="max-width: 360px" />
        </el-form-item>
        <el-form-item label="AppKey" prop="appKey">
          <el-input
            v-model="keyForm.appKey"
            :placeholder="hasAppKey ? '已配置 ' + appKeyMasked + '，留空不修改' : '领星 OMS AppKey'"
            style="max-width: 360px"
            clearable
            autocomplete="off"
            name="lx-app-key"
          />
        </el-form-item>
        <el-form-item label="AppSecret" prop="appSecret">
          <el-input
            v-model="keyForm.appSecret"
            :placeholder="hasAppSecret ? '已配置 ' + appSecretMasked + '，留空不修改' : '领星 OMS AppSecret'"
            style="max-width: 360px"
            clearable
            autocomplete="off"
            name="lx-app-secret"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" :loading="savingKey" @click="saveKey">保存</el-button>
          <el-button :loading="testing" @click="testKey">测通</el-button>
        </el-form-item>
      </el-form>
    </el-card>
  </div>
</template>

<script>
import httpApi from '@/http/api'

export default {
  name: 'DaifaIntegration',
  data() {
    return {
      loading: false,
      savingKey: false,
      testing: false,
      hasAppKey: false,
      hasAppSecret: false,
      appKeyMasked: '',
      appSecretMasked: '',
      keyForm: {
        appKey: '',
        appSecret: ''
      }
    }
  },
  created() {
    this.loadAll()
  },
  methods: {
    loadAll() {
      this.loading = true
      httpApi
        .getDaifaIntegration()
        .then(res => {
          if (res.data && res.data.code === 'ok') {
            const d = res.data.data || {}
            this.keyForm.appKey = ''
            this.keyForm.appSecret = ''
            this.hasAppKey = !!d.hasAppKey
            this.hasAppSecret = !!d.hasAppSecret
            this.appKeyMasked = d.appKeyMasked || ''
            this.appSecretMasked = d.appSecretMasked || ''
          } else {
            this.$message.error((res.data && res.data.message) || '加载失败')
          }
        })
        .catch(() => this.$message.error('网络错误'))
        .finally(() => {
          this.loading = false
        })
    },
    saveKey() {
      if (!this.hasAppKey && !this.keyForm.appKey) {
        this.$message.warning('首次保存请填写 AppKey')
        return
      }
      if (!this.hasAppSecret && !this.keyForm.appSecret) {
        this.$message.warning('首次保存请填写 AppSecret')
        return
      }
      this.savingKey = true
      httpApi
        .saveDaifaIntegration({
          appKey: this.keyForm.appKey,
          appSecret: this.keyForm.appSecret,
          syncDefaultShop: true
        })
        .then(res => {
          if (res.data && res.data.code === 'ok') {
            this.$message.success('保存成功')
            this.loadAll()
          } else {
            this.$message.error((res.data && res.data.message) || '保存失败')
          }
        })
        .catch(() => this.$message.error('网络错误'))
        .finally(() => {
          this.savingKey = false
        })
    },
    testKey() {
      this.testing = true
      httpApi
        .testDaifaIntegration()
        .then(res => {
          if (res.data && res.data.code === 'ok') {
            const d = res.data.data || {}
            if (d.success) {
              this.$message.success(d.message || '连接成功')
            } else {
              this.$message.error(d.message || '连接失败')
            }
          } else {
            this.$message.error((res.data && res.data.message) || '测通失败')
          }
        })
        .catch(() => this.$message.error('网络错误'))
        .finally(() => {
          this.testing = false
        })
    }
  }
}
</script>

<style scoped>
.daifa-integration {
  padding: 0 4px;
}
.main {
  margin-bottom: 16px;
}
.hint {
  color: #909399;
  font-size: 13px;
  line-height: 1.5;
  margin: 0 0 16px;
}
.key-form {
  max-width: 560px;
}
</style>
